import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    setIsAnimating(true);

    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 900); // loader süresi

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Sayfa fade olmasın
  const pageVariants = {
    initial: { opacity: 1 },
    animate: { opacity: 1 },
    exit: { opacity: 1 }
  };

  // Loader soft kaybolsun
  const loaderVariants = {
    initial: { opacity: 1, scale: 1 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95, transition: { duration: 0.6 } }
  };

  const appleVariants = {
    initial: { rotate: 0 },
    animate: {
      rotate: [0, -15, 15, -10, 10, 0],
      transition: { duration: 1, ease: "easeInOut" }
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(180deg, #fdf5e6 0%, #fffdf8 100%)",
        minHeight: "100vh",
        overflow: "hidden"
      }}
    >
      {/* Loader */}
      <AnimatePresence mode="wait">
        {isAnimating && (
          <motion.div
            key="loader"
            variants={loaderVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 1000,
              display: "grid",
              placeItems: "center",
              background: "transparent",
              pointerEvents: "none"
            }}
          >
            <motion.div
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                backgroundColor: "#fff",
                boxShadow: "0 0 15px rgba(0,0,0,0.12)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <motion.span
                variants={appleVariants}
                initial="initial"
                animate="animate"
                style={{ fontSize: "2.6rem",
                         marginBottom:7 }}
              >
                🍎
              </motion.span>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Sayfa içeriği → Loader bitene kadar tamamen gizli */}
      <div style={{ opacity: isAnimating ? 0 : 1, transition: "opacity 0.2s ease" }}>
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default PageTransition;
